import weddingTwo from "../../img/priser/bryllup/ellen-tjabe/bryllup-2-optimized.jpg";
import weddingThree from "../../img/priser/bryllup/ellen-tjabe/bryllup-3-optimized.jpg";
import weddingFour from "../../img/priser/bryllup/ellen-tjabe/bryllup-4-optimized.jpg";
import weddingFive from "../../img/priser/bryllup/ellen-tjabe/bryllup-5-optimized.jpg";
import weddingSix from "../../img/priser/bryllup/ellen-tjabe/bryllup-6-optimized.jpg";
import weddingSeven from "../../img/priser/bryllup/ellen-tjabe/bryllup-7-optimized.jpg";
import weddingEigth from "../../img/priser/bryllup/hedda-endre/bryllup-optimized.jpg";
import weddingTen from "../../img/priser/bryllup/hedda-endre/bryllup-3-optimized.jpg";
import weddingEleven from "../../img/priser/bryllup/mathea-andre/bryllup-3-optimized.jpg";
import weddingTwelve from "../../img/priser/bryllup/mathea-andre/bryllup-4-optimized.jpg";
import weddingThirteen from "../../img/priser/bryllup/mathea-andre/bryllup-5-optimized.jpg";
import weddingFourteen from "../../img/priser/bryllup/mathea-andre/bryllup-optimized.jpg";
import weddingFifteen from "../../img/priser/bryllup/mathea-andre/bryllup-6-optimized.jpg";
import weddingSixteen from "../../img/priser/bryllup/mathea-andre/bryllup-7-optimized.jpg";
import weddingNineteen from "../../img/priser/bryllup/sjomann/bryllup-4-optimized.jpg";
import weddingTwenty from "../../img/priser/bryllup/sjomann/bryllup-5-optimized.jpg";
import weddingTwentyOne from "../../img/priser/bryllup/sjomann/bryllup-optimized.jpg";

const weddingImagesArray = [
    weddingTwo,
    weddingThree,
    weddingFour,
    weddingFive,
    weddingSix,
    weddingSeven,
    weddingEigth,
    weddingTen,
    weddingEleven,
    weddingTwelve,
    weddingThirteen,
    weddingFourteen,
    weddingFifteen,
    weddingSixteen,
    weddingNineteen,
    weddingTwenty,
    weddingTwentyOne
]
export default weddingImagesArray